import { Button } from "reactstrap";
import PromptList from "./PromptList";

export default function PromptsForm({
    prompts, 
    buttonText="Continue",
    isSelected,
    getSelected,
    setSelected,
    isDisabled,
    onSubmit,
}) {
    return (
      <>
        {prompts.length > 0
          ? <PromptList
              prompts={prompts}
              isSelected={isSelected}
              getSelected={getSelected}
              setSelected={setSelected}
            />
          : <div>There are no details which need to be recorded for this intervention.</div>
        }
        <Button
          size="sm"
          color="primary"
          disabled={isDisabled}
          onClick={onSubmit}
        >
          {buttonText}
        </Button>
      </>
    );
}